/**
 * File messageBox.js
 * Description: File dùng trung gian để gọi thông báo
 * creatd by: nntam - 16/8/2019
 */
import Vue from 'vue';
import i18n from '@/i18n/i18n';
import MsMessageBox from '@/components/ms-message-box/MsMessageBox';

class MessageBox {
	show(option) {
		let promise = new Promise((resolve, reject) => {
			const me = this;
			// cấu hình button mặt định
			let btnConfigDefault = [
				{
					key: 'Cancel',
					hasBtn: false,
					target: 'Left',
					text: 'Hủy',
					typeButton: 'secondary'
				},
				{
					key: 'Close',
					hasBtn: false,
					target: 'Center',
					text: 'Đóng',
					typeButton: 'primary'
				},
				{
					key: 'Yes',
					hasBtn: false,
					target: 'RightSecond',
					text: 'Đồng ý',
					typeButton: 'secondary',
					focus: true
				},
				{
					key: 'No',
					hasBtn: false,
					target: 'RightFirst',
					text: 'Hủy',
					typeButton: 'third-white'
				}
			];

			// merge cấu hình người dùng với cấu hình mặc định
			// nntam - 16/04/2020: bổ sung thêm truyền vào loại button (typeButton)
			if (option.btnConfig != null) {
				btnConfigDefault.forEach(element => {
					element.hasBtn = false;
					option.btnConfig.forEach(e => {
						if (element.key === e.key) {
							element.target = e.target;
							element.hasBtn = true;
							element.text = e.text ? e.text : element.text;
							element.focus = e.focus;
							element.typeButton = e.typeButton
								? e.typeButton
								: element.typeButton;
						}
					});
				});
			}

			// gán lại cấu hình mặc định với các tham số người dùng gửi vào
			let optionDefault = {
				message: option.message,
				component: option.component ? option.component : null,
				messageDetail: option.messageDetail ? option.messageDetail : '',
				titleIcon: option.titleIcon ? option.titleIcon : '',
				icon:
					option.icon == false
						? false
						: option.icon
							? option.icon
							: 'mi-icon-waring-55',
				line: option.line == false ? false : true,
				btnConfig: btnConfigDefault,
				closeMessageAfterLink: option.closeMessageAfterLink,
				close: option.close,
				width: option.width ? option.width : '444px',
				title: option.title ? option.title : null,
				widthForm: option.widthForm ? option.widthForm : null,
			};

			let zz = new Vue({
				el: '#message-box',
				i18n,
				render: function (h) {
					// const vv = {
					//   on: {
					//     ttt(val) {
					//       a = val;
					//       this.$emit('messageClick', val);
					//     }
					//   }
					// }
					return (
						<MsMessageBox
							ref="msgBox"
							option={optionDefault}
						//  {...vv}
						>
							{' '}
						</MsMessageBox>
					);
				},
				computed: {},
				methods: {},
				components: {
					MsMessageBox
				}
			});
			// nhận sự kiện click vào button
			let msgBox = zz.$refs.msgBox;
			if (msgBox) {
				msgBox.$on('btnClick', function (msg, action) {
					resolve(action);
				});
				// hngiap - 26.05.2020: Bổ sung callback thêm tham số resolve, reject để
				// - Xử lý trường hợp await action của msgBox cần resolve để chạy tiếp
				msgBox.$on('linkActive', function () {
					me.customLinkActive(resolve, reject);
				});
				msgBox.$on('linkGuide', function () {
					me.customLinkGuide();
				});
				msgBox.$on('linkPopup', this.customLinkPopup);
				let firstBtn = msgBox.$el.querySelector('button');
				if (firstBtn) {
					firstBtn.focus();
				}
			}
		});

		return promise;
	}

	customLinkActive(resolve, reject) { }

	customLinkGuide() { }

	customLinkPopup() { }
	/**
	 * Hàm hiện thị message box câu hỏi
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	showQuestion(message, messageDetail) {
		// cấu hình mặc định với msg Question
		let option = {
			message: message,
			messageDetail: messageDetail,
			icon: 'mi-exclamation-question-48',
			line: true,
			btnConfig: [
				{
					key: 'Cancel',
					target: 'Left',
					text: 'Hủy'
				},
				{
					key: 'No',
					target: 'RightFirst',
					text: 'Hủy'
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: 'Đồng ý',
					focus: true
				}
			]
		};

		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box cảnh báo
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	showWarning(message, messageDetail) {
		// cấu hình mặc định với msgWarning
		let option = {
			message: message,
			messageDetail: messageDetail,
			icon: 'mi-icon-waring-55',
			line: true,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: 'Đóng',
					focus: true
				}
			]
		};
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box lỗi
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	showError(message, messageDetail, title) {
		// cấu hình mặc định với msg Error
		let option = {
			message: message,
			messageDetail: messageDetail == '' ? messageDetail : null,
			icon: 'mi-icon-error-warning',
			line: true,
			title: title,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: 'Đóng',
					focus: true
				}
			]
		};
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box thông tin
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	showInfo(message, messageDetail) {
		// cấu hình mặc định với info
		let option = {
			message: message,
			messageDetail: messageDetail,
			icon: 'mi-exclamation-info-48',
			line: true,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: 'Đóng',
					focus: true
				}
			]
		};
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box xác nhận
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	async showConfirm(message, customOptions) {
		// cấu hình mặc định với msg confirm
		let option = {
			message: message,
			messageDetail: null,
			icon: 'mi-icon-waring-55',
			line: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: 'Hủy'
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: 'Đồng ý',
					focus: true
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box xác nhận Có không
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	async showConfirmNext(message, customOptions) {
		// cấu hình mặc định với msg confirm
		let option = {
			message: message,
			messageDetail: null,
			icon: 'mi-icon-waring-55',
			line: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: 'Không'
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: 'Có',
					focus: true
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box thành công
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 * created by ntphong 19/3/2020
	 */
	showSuccess(message, messageDetail) {
		// cấu hình mặc định với info
		let option = {
			message: message,
			messageDetail: messageDetail,
			icon: 'mi-exclamation-success',
			line: true,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: 'Đóng',
					focus: true
				}
			]
		};
		return this.show(option);
	}
}

export default new MessageBox();
